module.exports = __webpack_public_path__ + "rosacea_6_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/rosacea_6_before.jpg
// module id = 988
// module chunks = 0